import React, { useMemo, useState, useEffect, useLayoutEffect, useRef, useCallback } from "react";
import { Box, Button, Text, VStack, Heading, HStack, ButtonGroup, Tooltip, IconButton, } from "@chakra-ui/react";
import styles from "../Ace.module.css";
import { connect } from "react-redux";
import { Resize1, Resize2 } from "../icons";
import { ChevronDownIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { removeLines, shouldRemoveHiddenLine } from "../ReusableFunctions";
import { applyAcceptToEditor, cleanupItem } from '../SuggestionAction';
import UseSetAllFiles from "../Customhook/UseSetAllFiles";
import { acceptItem, rejectItem, removeFromGlobalAnchorList } from "../AutoSuggestion";
const EditCorrections = (props) => {
  const [openGroups, setOpenGroups] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [viewMode, setViewMode] = useState("all");
  const { Allfiles, setAllFiles } = UseSetAllFiles();
  // ── Scroll preservation ──
  const scrollContainerRef = useRef(null);
  const savedScrollTop = useRef(0);

  const handleScroll = useCallback(() => {
    if (scrollContainerRef.current) {
      savedScrollTop.current = scrollContainerRef.current.scrollTop;
    }
  }, []);

  // Restore scroll after every render, but only when NOT in initial-load state
  useLayoutEffect(() => {
    const el = scrollContainerRef.current;
    if (!el) return;
    if (savedScrollTop.current > 0) {
      el.scrollTop = savedScrollTop.current;
    }
  }); // intentionally no deps — runs after every render

  const toggleGroup = (name) => {
    setOpenGroups((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };
  console.log("the data in the :", props.autoSuggestion)

  const moveToPosition = (item) => {
    const editor = props.ace.current.editor;
    editor.session.selection.setRange({
      start: { row: item.startAnchor.row, column: item.startAnchor.column },
      end: { row: item.endAnchor.row, column: item.endAnchor.column },
    });
    editor.scrollToLine(item.startAnchor.row, true, true);
    editor.focus();
  };

  const insertQuery = (item) => {
    if (!item || !item.startAnchor) return;
    const editor = props.ace.current.editor;
    const session = editor.session;
    try {
      const row = item.startAnchor.row;
      const styleName = item.styleInfo?.description || "Query";
      const queryText = `\\AQ{${styleName}}\n`;
      session.insert({ row, column: 0 }, queryText);
      editor.gotoLine(row + 1, 0);
      editor.scrollToLine(row, true, true);
      if (props.setTextFile) props.setTextFile(session.getValue());
    } catch (error) {
      console.error("Error inserting query:", error);
    }
  };
  const acceptSuggestion = (item) => {
    if (!item?.startAnchor || !item?.endAnchor) return;
    acceptItem(props.ace.current.editor, item, props.setTextFile, props, setAllFiles);
  };

  const rejectSuggestion = (item) => {
    if (!item?.startAnchor) return;
    const editor = props.ace.current.editor;
    rejectItem(editor, item, props);  // ← editor first, then item, then props
  };

  const acceptAllSuggestions = (items) => {
    [...items].reverse().forEach(item => acceptSuggestion(item));
  };

  const rejectAllSuggestions = (items) => {
    [...items].reverse().forEach(item => rejectSuggestion(item));
  };

  const handleClearAll = () => {
    const editor = props.ace.current.editor;
    const session = editor.session;
    // props.editToolAction({});
    // props.toolStyles({ key: null, data: [], isChecked: false });
    props.editToolRejected();
    props.NoSuggestions();

    props.autoSuggestions.forEach(item => {
      if (item.markerId) session.removeMarker(item.markerId);
      if (item.startAnchor?.detach) item.startAnchor.detach();
      if (item.endAnchor?.detach) item.endAnchor.detach();
    });

    props.clearAutoSuggestions();
    props.clearAutoSuggestionRejects();
    props.triggerClearAll();
  };

  const filteredSuggestions = useMemo(() => {
    const suggestions = props.autoSuggestions || [];
    const rejected = props.autoSuggestionsRejected || [];
    const rejectedIds = new Set(rejected.map(r => r.id));
    // ── REMOVE THIS LINE — it belongs in reducer not here ──
    // const already = props.autoSuggestionReject.some(r => r.id === action.payload.id);
    return suggestions.filter(item => !rejectedIds.has(item.id));
  }, [props.autoSuggestions, props.autoSuggestionsRejected]);

  const groupedSuggestions = useMemo(() => {
    return filteredSuggestions.reduce((acc, item) => {
      const styleName = item.styleInfo.name;
      if (!acc[styleName]) acc[styleName] = [];
      acc[styleName].push(item);
      return acc;
    }, {});
  }, [filteredSuggestions]);

  const filteredGroupedSuggestions = useMemo(() => {
    if (!searchQuery.trim()) return groupedSuggestions;
    const q = searchQuery.toLowerCase();
    return Object.fromEntries(
      Object.entries(groupedSuggestions).filter(([styleName]) => styleName.toLowerCase().includes(q))
    );
  }, [groupedSuggestions, searchQuery]);

  const displayedSuggestions = useMemo(() => {
    return Object.fromEntries(
      Object.entries(filteredGroupedSuggestions).filter(([, items]) => {
        if (viewMode === "queries") return items[0]?.queryOnly === true;
        if (viewMode === "styles") return !items[0]?.queryOnly;
        return true;
      })
    );
  }, [filteredGroupedSuggestions, viewMode]);

  const isEmpty = Object.keys(displayedSuggestions).length === 0;
  const TRUNCATE_LIMIT = 40;

  const TruncatedText = ({ text, label, color }) => {
    const [expanded, setExpanded] = useState(false);
    const displayText = text === " " ? "<space>" : text.replace(/\n/g, "\\n");
    const isTruncatable = displayText.length > TRUNCATE_LIMIT;

    return (
      <Heading fontSize="15px" display="flex" gap="4px" color="#333333" width="100%" whiteSpace="pre-wrap">
        <span style={{ color, fontWeight: "600", flexShrink: 0 }}>{label} </span>
        <span style={{ wordBreak: "break-all", fontWeight: "600" }}>
          {isTruncatable && !expanded ? (
            <>
              {displayText.slice(0, TRUNCATE_LIMIT)}
              <span
                onClick={(e) => { e.stopPropagation(); setExpanded(true); }}
                style={{ color: "#3498db", cursor: "pointer", fontWeight: "500" }}
              >
                ...
              </span>
            </>
          ) : (
            <>
              {displayText}
              {isTruncatable && (
                <span
                  onClick={(e) => { e.stopPropagation(); setExpanded(false); }}
                  style={{ color: "#3498db", cursor: "pointer", fontWeight: "500", marginLeft: "4px" }}
                >
                  {" "}show less
                </span>
              )}
            </>
          )}
        </span>
      </Heading>
    );
  };

  return (
    <>
      <div className={styles.header}>
        <HStack
          backgroundColor="var(--primary-main)"
          justifyContent="space-between"
          h="48px"
          width="auto"
          zIndex={10}
        >
          <ButtonGroup spacing="1">
            <Button color="white" background="black" size="lg" zIndex={10} colorScheme="#f47c0d" aria-label="Suggestions">
              Suggestions ({filteredSuggestions.length})
            </Button>
            <Box display="flex" position={"absolute"} right={0}>
              <Button
                onClick={handleClearAll}
                color="white" size="lg" colorScheme="#f47c0d" aria-label="Clear All"
                _hover={{ bg: "var(--secondary-main)" }}
              >
                Clear All
              </Button>
              {props.pdfFull ? (
                <Tooltip label="Minimize">
                  <IconButton onClick={props.toggleEditor} size="lg" bg="var(--primary-main)"
                    aria-label="Resize" icon={<Resize2 />} _hover={{ bg: "var(--secondary-main)" }} />
                </Tooltip>
              ) : (
                <Tooltip label="Maximize">
                  <IconButton onClick={props.toggleEditor} size="lg" colorScheme="#f47c0d"
                    aria-label="Resize" icon={<Resize1 />} bg="var(--primary-main)"
                    _hover={{ bg: "var(--secondary-main)" }} />
                </Tooltip>
              )}
            </Box>
          </ButtonGroup>
        </HStack>
      </div>

      {/* Search + filter bar */}
      <Box px="4" py="2" borderBottom="1px solid #e2e8f0" backgroundColor="white">
        <HStack gap="8px">
          <input
            aria-label="Search styles"
            type="text"
            placeholder="Search styles..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{
              flex: 1, padding: "8px 12px", border: "1px solid #e2e8f0",
              borderRadius: "8px", fontSize: "14px", outline: "none",
              color: "#333", backgroundColor: "#f9f9f9",
            }}
            onFocus={(e) => e.target.style.borderColor = "#3498db"}
            onBlur={(e) => e.target.style.borderColor = "#e2e8f0"}
          />
          <select
            aria-label="Filter by type"
            value={viewMode}
            onChange={(e) => setViewMode(e.target.value)}
            style={{
              padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: "8px",
              fontSize: "14px", outline: "none", color: "#333",
              backgroundColor: "#f9f9f9", cursor: "pointer", minWidth: "90px",
            }}
            onFocus={(e) => e.target.style.borderColor = "#3498db"}
            onBlur={(e) => e.target.style.borderColor = "#e2e8f0"}
          >
            <option value="all">All</option>
            <option value="queries">Queries</option>
            <option value="styles">Styles</option>
          </select>
        </HStack>
      </Box>

      {/* ── Loading indicator: subtle bar at top, NOT replacing the list ── */}
      {props.isLoadingSuggestions && (
        <div style={{ flexShrink: 0 }}>
          <div style={{
            height: "3px",
            background: "linear-gradient(90deg, var(--primary-main) 0%, #f47c0d 50%, var(--primary-main) 100%)",
            backgroundSize: "200% 100%",
            animation: "loadingBar 1.2s linear infinite",
          }} />
          <div style={{
            padding: "6px 0",
            textAlign: "center",
            fontSize: "13px",
            fontWeight: "500",
            color: "rgba(0,0,0,0.5)",
            backgroundColor: "#fffdf9",
            borderBottom: "1px solid #f0e8e0",
          }}>
            Loading suggestions...
          </div>
        </div>
      )}
      <div
        ref={scrollContainerRef}
        onScroll={handleScroll}
        style={{
          overflowY: "auto",
          overflowX: "hidden",
          height: "84vh",
          display: "flex",
          flexDirection: "column",
          gap: 0,
          scrollbarWidth: "thin",
          scrollbarColor: "#888 #f1f1f1",
        }}
      >
        {!isEmpty ? (
          Object.entries(displayedSuggestions).map(([styleName, items]) => (
            // KEY CHANGE: use styleName not groupIndex — stable keys prevent remount
            <div key={styleName} style={{ width: "100%" }}>
              <Box borderRadius="md">
                {/* Group Header */}
                <HStack
                  backgroundColor="#F5F5F5"
                  justifyContent="space-between"
                  alignItems="center"
                  borderBottom="1px solid #e2e8f0"
                  px="3" py="3"
                  cursor="pointer"
                  onClick={() => toggleGroup(styleName)}
                  _hover={{ backgroundColor: "#EEEEEE" }}
                >
                  <HStack gap="2" alignItems="center">
                    {openGroups[styleName]
                      ? <ChevronDownIcon w={5} h={5} color="black" />
                      : <ChevronRightIcon w={5} h={5} color="black" />
                    }
                    <Text fontSize="16px" fontWeight="medium" color="black">{styleName}</Text>
                  </HStack>

                  <HStack gap="8px" paddingRight="20px" onClick={(e) => e.stopPropagation()}>
                    <Text fontSize="14px" color="gray.600" fontWeight="normal">({items.length})</Text>
                    {!items[0]?.queryOnly && (
                      <>
                        <Button
                          display="flex" gap="8px" borderRadius="8px" padding="8px 10px"
                          variant="outline" backgroundColor="white" border="1px solid #E0DBD7"
                          size="sm" color="#504C4A"
                          onClick={(e) => { e.stopPropagation(); acceptAllSuggestions(items); }}
                          _hover={{ backgroundColor: "#f0f0f0" }}
                        >
                          <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                            <path d="M13.3337 4L6.00033 11.3333L2.66699 8" stroke="#208923" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          Accept All
                        </Button>
                        <Button
                          variant="outline" display="flex" gap="8px" borderRadius="8px" padding="8px 10px"
                          backgroundColor="white" border="1px solid #E0DBD7" size="sm" color="#504C4A"
                          onClick={(e) => { e.stopPropagation(); rejectAllSuggestions(items); }}
                          _hover={{ backgroundColor: "#f0f0f0" }}
                        >
                          <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                            <path d="M12 4L4 12" stroke="#E30F0F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M4 4L12 12" stroke="#E30F0F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          Reject All
                        </Button>
                      </>
                    )}
                  </HStack>
                </HStack>
                {openGroups[styleName] && items.map((item, i) => (
                  <Box
                    key={i} p="4" paddingRight="32px"
                    display="flex" justifyContent="space-between" alignItems="center"
                    gap="20px" cursor="pointer"
                    onClick={() => moveToPosition(item)}
                    style={{ borderBottom: "1px solid #eee" }}
                    _hover={{ backgroundColor: "#f9f9f9" }}
                  >
                    <Box width="calc(100% - 130px)">
                      {item.queryOnly ? (
                        <>
                          <Text fontSize="14px" color="#333333" fontWeight="500">{item.styleInfo?.description}</Text>
                          <Text fontSize="12px" color="gray.500" mt="6px">
                            Line {item.startAnchor.row + 1}, Column {item.startAnchor.column + 1}
                          </Text>
                        </>
                      ) : (
                        <>
                          <TruncatedText
                            text={item.originalText}
                            label="Original:"
                            color="#E30F0F"
                          />
                          {item.suggestionText && item.suggestionText.trim() && (
                            <TruncatedText
                              text={item.suggestionText}
                              label="Suggested:"
                              color="#208923"
                            />
                          )}
                          <Text fontSize="12px" color="gray.500" mt="6px">
                            Line {item.startAnchor.row + 1}, Column {item.startAnchor.column + 1}
                          </Text>
                        </>
                      )}
                    </Box>

                    <HStack minWidth="130px" justifyContent="flex-end" gap="6px" onClick={(e) => e.stopPropagation()}>
                      {item.queryOnly ? (
                        <Button
                          size="sm" variant="outline" width="auto" height="fit-content"
                          border="1px solid #3498db" borderRadius="20px" padding="7px" color="#3498db"
                          onClick={(e) => { e.stopPropagation(); insertQuery(item); }}
                          _hover={{ backgroundColor: "#e3f2fd" }}
                        >
                          query
                        </Button>
                      ) : (
                        <>
                          <Button
                            size="sm" variant="outline" width="auto" height="fit-content"
                            border="1px solid #DDDDDD" borderRadius="20px" padding="7px"
                            onClick={(e) => { e.stopPropagation(); acceptSuggestion(item); }}
                            _hover={{ backgroundColor: "#e8f5e9" }}
                          >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                              <path d="M13.3337 4L6.00033 11.3333L2.66699 8" stroke="#208923" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </Button>
                          <Button
                            size="sm" variant="outline" width="auto" height="fit-content"
                            border="1px solid #DDDDDD" borderRadius="20px" padding="7px"
                            onClick={(e) => { e.stopPropagation(); rejectSuggestion(item); }}
                            _hover={{ backgroundColor: "#ffebee" }}
                          >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                              <path d="M12 4L4 12" stroke="#E30F0F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M4 4L12 12" stroke="#E30F0F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </Button>
                          <Button
                            size="sm" variant="outline" width="auto" height="fit-content"
                            border="1px solid #3498db" borderRadius="20px" padding="7px" color="#3498db"
                            onClick={(e) => { e.stopPropagation(); insertQuery(item); }}
                            _hover={{ backgroundColor: "#e3f2fd" }}
                          >
                            query
                          </Button>
                        </>
                      )}
                    </HStack>
                  </Box>
                ))}
              </Box>
            </div>
          ))
        ) : (
          !props.isLoadingSuggestions && (
            <Box
              display="flex" alignItems="center" justifyContent="center"
              height="100%" flexDirection="column" gap="8px"
            >
              <Text fontSize="20px" fontWeight="500" color="rgba(0, 0, 0, 0.6)">No Suggestions</Text>
              <Text fontSize="14px" color="rgba(0, 0, 0, 0.4)">
                Suggestions will appear here when available
              </Text>
            </Box>
          )
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state, ownProps) => ({
  autoSuggestions: state.autoSuggestion.suggestions,
  ischecked: state.autoSuggestion.ischecked,
  autoSuggestionsRejected: state.editToolRejected.autoSuggestionReject,
  ace: ownProps.ace,
  setTextFile: ownProps.setTextFile,
  pdfFull: ownProps.pdfFull,
  toggleEditor: ownProps.toggleEditor,
  showSuggestions: state.editToolRejected.showSuggestions,
  isLoadingSuggestions: state.editToolRejected.isLoadingSuggestion,
  clearAllTrigger: state.editToolRejected.clearAllTrigger,

  autoSuggestionsRejected: state.editToolRejected.autoSuggestionReject,
});

const mapDispatchToProps = (dispatch) => ({
  addAutoSuggestion: (data) => dispatch({ type: "addAutoSuggestion", payload: data }),
  removeAutoSuggestion: (data) => dispatch({ type: "removeAutoSuggestion", payload: data }),
  clearAutoSuggestions: () => dispatch({ type: "clearAutoSuggestion" }),
  addAutoSuggestionReject: (data) => dispatch({ type: "AddAutoSuggestionReject", payload: data }),
  clearAutoSuggestionRejects: () => dispatch({ type: "EmptyAutoSuggestionReject" }),
  editToolAction: (data) => dispatch({ type: "EDITTOOL", payload: data }),
  toolStyles: (data) => dispatch({ type: "ToolSubmit", payload: data }),
  editToolRejected: () => dispatch({ type: "EmptyReject", payload: [] }),
  NoSuggestions: () => dispatch({ type: "Dontshowsuggestion" }),
  triggerClearAll: () => dispatch({ type: "triggerClearAll" }),
  removeStaleAutoSuggestions: (ids) => dispatch({ type: "removeStaleAutoSuggestions", payload: ids }),

});

export default connect(mapStateToProps, mapDispatchToProps)(EditCorrections);